import React, { useState } from 'react';
import { FiCalendar, FiSun, FiLogOut, FiLogIn, FiAlertTriangle, FiChevronRight, FiInfo, FiCheck, FiCornerDownRight } from 'react-icons/fi';
import { MdOutlineMoreTime } from "react-icons/md";
import AdvanceLeave from './AdvanceLeave';
import HalfDayLeave from './HalfDayLeave';
import EarlyLeave from './EarlyLeave';
import LateArrival from './LateArrival';
import TimeBreak from './TimeBreak';
import EmergencyLeave from './EmergencyLeave';
import Cookies from 'js-cookie';

const LeaveForm = () => {
    const [selectedLeave, setSelectedLeave] = useState(null);

    // Fetch logged in user to show dynamic hierarchy logic
    const loginDataStr = Cookies.get("loginData");
    let loginData = null;
    if (loginDataStr) {
        loginData = JSON.parse(loginDataStr);
    }
    const applicantUser = loginData?.data || loginData?.user || {};
    const role = applicantUser.Role;

    let firstApproverName = "Assigned Approver";
    let firstApproverRoleDesc = "Senior Developer";

    if (role === "Delphi Junior Developer") {
        firstApproverName = "KALPESH DILKHUSH";
        firstApproverRoleDesc = "Delphi Senior Developer";
    } else if (role === "Web Junior Developer") {
        firstApproverName = "JAY PARMAR";
        firstApproverRoleDesc = "Web Senior Developer";
    } else if (role === "Junior Customer Support") {
        firstApproverName = "VIPUL KANTHARIA";
        firstApproverRoleDesc = "Senior Customer Support";
    }

    const leaveTypes = [
        {
            title: 'Advance Leave',
            description: 'Plan and secure your leave days in advance.',
            icon: <FiCalendar className="w-5 h-5" />,
            colorClass: 'from-blue-50/70 to-indigo-50/40 border-blue-200/80 hover:border-blue-400',
            iconBg: 'bg-blue-600 border-blue-600 text-white',
            textClass: 'text-blue-950',
            descClass: 'text-blue-800',
            linkClass: 'text-blue-700',
            hoverGlow: 'hover:shadow-[0_20px_40px_rgba(59,130,246,0.08)]'
        },
        {
            title: 'Half Day Leave',
            description: 'Take a half-day off for personal errands.',
            icon: <FiSun className="w-5 h-5" />,
            colorClass: 'from-amber-50/70 to-yellow-50/40 border-amber-200/80 hover:border-amber-400',
            iconBg: 'bg-amber-600 border-amber-600 text-white',
            textClass: 'text-amber-950',
            descClass: 'text-amber-800',
            linkClass: 'text-amber-700',
            hoverGlow: 'hover:shadow-[0_20px_40px_rgba(245,158,11,0.08)]'
        },
        {
            title: 'Early Leave',
            description: 'Leave shift early for urgent requirements.',
            icon: <FiLogOut className="w-5 h-5" />,
            colorClass: 'from-purple-50/70 to-fuchsia-50/40 border-purple-200/80 hover:border-purple-400',
            iconBg: 'bg-purple-600 border-purple-600 text-white',
            textClass: 'text-purple-950',
            descClass: 'text-purple-800',
            linkClass: 'text-purple-700',
            hoverGlow: 'hover:shadow-[0_20px_40px_rgba(168,85,247,0.08)]'
        },
        {
            title: 'Late Arrival',
            description: 'Log delay and arrive past normal start time.',
            icon: <FiLogIn className="w-5 h-5" />,
            colorClass: 'from-orange-50/70 to-red-50/40 border-orange-200/80 hover:border-orange-400',
            iconBg: 'bg-orange-600 border-orange-600 text-white',
            textClass: 'text-orange-950',
            descClass: 'text-orange-850',
            linkClass: 'text-orange-700',
            hoverGlow: 'hover:shadow-[0_20px_40px_rgba(249,115,22,0.08)]'
        },
        {
            title: 'Time Break',
            description: 'Request an official temporary break mid-shift.',
            icon: <MdOutlineMoreTime className="w-5 h-5" />,
            colorClass: 'from-emerald-50/70 to-teal-50/40 border-emerald-200/80 hover:border-emerald-400',
            iconBg: 'bg-emerald-600 border-emerald-600 text-white',
            textClass: 'text-emerald-950',
            descClass: 'text-emerald-800',
            linkClass: 'text-emerald-700',
            hoverGlow: 'hover:shadow-[0_20px_40px_rgba(16,185,129,0.08)]'
        },
        {
            title: 'Emergency Leave',
            description: 'Urgent, unplanned leaves notified instantly.',
            icon: <FiAlertTriangle className="w-5 h-5" />,
            colorClass: 'from-rose-50/70 to-pink-50/40 border-rose-200/80 hover:border-rose-400',
            iconBg: 'bg-rose-600 border-rose-600 text-white',
            textClass: 'text-rose-950',
            descClass: 'text-rose-800',
            linkClass: 'text-rose-700',
            hoverGlow: 'hover:shadow-[0_20px_40px_rgba(244,63,94,0.08)]'
        }
    ];

    return (
        <div className="px-3 py-6 min-h-0 bg-gradient-to-br from-slate-50/50 via-white to-slate-50/20 font-sans">
            <div className="w-full space-y-6">
                {/* Page Title */}
                <div className="title mb-4">
                    <h3 className="text-xl font-bold main_title_page text-white px-4 py-2 inline-block rounded">
                        Apply for Leave
                    </h3>
                </div>

                {selectedLeave ? (
                    <div className="flex flex-col lg:flex-row gap-8 animate-in fade-in duration-300">
                        {/* Selected Form Block */}
                        <div className="lg:w-[68%] w-full bg-white rounded-2xl border border-slate-100 shadow-[0_15px_40px_rgba(0,0,0,0.02)] p-6 md:p-8">
                            {selectedLeave === 'Advance Leave' && <AdvanceLeave onBack={() => setSelectedLeave(null)} />}
                            {selectedLeave === 'Half Day Leave' && <HalfDayLeave onBack={() => setSelectedLeave(null)} />}
                            {selectedLeave === 'Early Leave' && <EarlyLeave onBack={() => setSelectedLeave(null)} />}
                            {selectedLeave === 'Late Arrival' && <LateArrival onBack={() => setSelectedLeave(null)} />}
                            {selectedLeave === 'Time Break' && <TimeBreak onBack={() => setSelectedLeave(null)} />}
                            {selectedLeave === 'Emergency Leave' && <EmergencyLeave onBack={() => setSelectedLeave(null)} />}
                        </div>

                        {/* Sidebar Details Block */}
                        <div className="lg:w-[32%] w-full space-y-6">
                            {/* Approval Flow Timeline Card */}
                            <div className="w-full bg-gradient-to-br from-white to-slate-50/70 border border-slate-100 rounded-2xl p-6 shadow-[0_15px_40px_rgba(0,0,0,0.02)] relative overflow-visible">
                                <h3 className="font-bold text-xs text-[#133A69] mb-8 uppercase tracking-widest flex items-center gap-2">
                                    <div className="w-1.5 h-3.5 bg-blue-500 rounded-full"></div>
                                    Approval Flow
                                </h3>

                                <div className="space-y-8 pl-8 relative before:absolute before:left-[17px] before:top-2 before:bottom-2 before:w-[2px] before:bg-slate-200/60">
                                    {role !== "inhouse" && role !== "Data Analyst" && (
                                        <div className="relative group">
                                            {/* Checkpoint Badge */}
                                            <div className="absolute -left-[27px] top-1.5 z-10 flex items-center justify-center">
                                                <div className="w-5 h-5 rounded-full bg-blue-600 text-white flex items-center justify-center text-[10px] font-black shadow-md shadow-blue-500/20 ring-4 ring-blue-50">
                                                    {role === "Web Junior Developer" || role === "Web Senior Developer" ? 1 : 2}
                                                </div>
                                            </div>
                                            <div>
                                                <span className="text-[10px] font-semibold text-slate-500 uppercase tracking-widest">{firstApproverRoleDesc}</span>
                                                <h4 className="text-sm font-bold text-slate-800 mt-0.5">{firstApproverName}</h4>
                                                <div className="mt-1 flex items-center gap-1.5 text-[10px] text-amber-800 font-bold bg-amber-50 px-2 py-0.5 rounded border border-amber-200 w-fit uppercase tracking-wider">
                                                    Initial Review
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    <div className="relative group">
                                        {/* Checkpoint Badge */}
                                        <div className="absolute -left-[27px] top-1.5 z-10 flex items-center justify-center">
                                            <div className="w-5 h-5 rounded-full bg-blue-600 text-white flex items-center justify-center text-[10px] font-black shadow-md shadow-blue-500/20 ring-4 ring-blue-50">
                                                {role === "Web Junior Developer" || role === "Web Senior Developer" ? 2 : 1}
                                            </div>
                                        </div>
                                        <div>
                                            <span className="text-[10px] font-semibold text-slate-500 uppercase tracking-widest">Delphi Senior Developer</span>
                                            <h4 className="text-sm font-bold text-slate-800 mt-0.5">DIPAK RAJPUT</h4>
                                            <div className="mt-1 flex items-center gap-1.5 text-[10px] text-amber-800 font-bold bg-amber-50 px-2 py-0.5 rounded border border-amber-200 w-fit uppercase tracking-wider">
                                                Technical Verification
                                            </div>
                                        </div>
                                    </div>

                                    <div className="relative group">
                                        {/* Checkpoint Badge */}
                                        <div className="absolute -left-[27px] top-1.5 z-10 flex items-center justify-center">
                                            <div className="w-5 h-5 rounded-full bg-blue-600 text-white flex items-center justify-center text-[10px] font-black shadow-md shadow-blue-500/20 ring-4 ring-blue-50">
                                                {role === "Web Junior Developer" || role === "Web Senior Developer" ? 3 : 2}
                                            </div>
                                        </div>
                                        <div>
                                            <span className="text-[10px] font-semibold text-slate-500 uppercase tracking-widest">Company Head</span>
                                            <h4 className="text-sm font-bold text-slate-800 mt-0.5">Owner</h4>
                                            <div className="mt-1 flex items-center gap-1.5 text-[10px] text-blue-800 font-bold bg-blue-50 px-2 py-0.5 rounded border border-blue-200 w-fit uppercase tracking-wider">
                                                Final Decision
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Guidelines Card */}
                            <div className="bg-gradient-to-br from-[#f8fafc] to-[#eff6ff] rounded-2xl border border-blue-100/60 p-6 shadow-sm">
                                <div className="flex items-center gap-3 mb-5 border-b border-blue-100/20 pb-4">
                                    <div className="w-8 h-8 rounded-xl bg-blue-600 text-white flex items-center justify-center shadow-md">
                                        <FiInfo className="w-4 h-4" />
                                    </div>
                                    <div>
                                        <h3 className="font-bold text-xs text-[#1e3a8a] tracking-widest uppercase">Leave Guidelines</h3>
                                        <p className="text-[10px] font-semibold text-slate-500 uppercase tracking-wider">Please follow the handbook regulations</p>
                                    </div>
                                </div>
                                <ul className="space-y-4">
                                    {[
                                        "Advance leave requires 7 days notice",
                                        "Emergency leave notifies instantly",
                                        "Half day deducts 0.5 days"
                                    ].map((item, i) => (
                                        <li key={i} className="flex items-start gap-3 text-xs font-bold text-slate-650 leading-relaxed">
                                            <FiCornerDownRight className="w-3.5 h-3.5 text-blue-500 shrink-0 mt-0.5" />
                                            {item}
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        </div>
                    </div>
                ) : (
                    /* Initial Leave Types Option Grid */
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 animate-in zoom-in-95 duration-300">
                        {leaveTypes.map((leave, index) => (
                            <button
                                key={index}
                                onClick={() => setSelectedLeave(leave.title)}
                                className={`bg-gradient-to-br ${leave.colorClass} border rounded-2xl p-5 transition-all duration-300 cursor-pointer text-left w-full group relative overflow-hidden flex flex-col justify-between h-[170px] ${leave.hoverGlow} active:scale-95`}
                            >
                                <div>
                                    {/* Icon Badge container */}
                                    <div className={`w-10 h-10 rounded-xl flex items-center justify-center shadow-sm border mb-3 transition-all duration-300 ${leave.iconBg}`}>
                                        {leave.icon}
                                    </div>

                                    {/* Titles */}
                                    <div className="relative z-10 space-y-0.5">
                                        <h3 className={`font-bold text-sm ${leave.textClass} transition-colors`}>{leave.title}</h3>
                                        <p className={`${leave.descClass} text-xs font-medium leading-relaxed pr-2`}>{leave.description}</p>
                                    </div>
                                </div>

                                {/* Apply Button Link */}
                                <div className={`mt-3 flex items-center text-xs font-bold ${leave.linkClass} uppercase tracking-wider opacity-0 group-hover:opacity-100 transition-all duration-300 translate-y-2 group-hover:translate-y-0 relative z-10`}>
                                    Apply Now <FiChevronRight className="ml-1 w-3.5 h-3.5 transition-transform group-hover:translate-x-0.5" />
                                </div>

                                {/* Decorative subtle background circle */}
                                <div className="absolute -right-6 -bottom-6 w-24 h-24 bg-slate-100/50 rounded-full opacity-60 group-hover:scale-150 transition-transform duration-700 -z-0"></div>
                            </button>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default LeaveForm;